import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Container, Form, Modal, Row, Spinner, Table, Card } from 'react-bootstrap'
import ApiService from '../ApiService'
import { Auth } from '@aws-amplify/auth'
import DatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'
import removeClass from '../util/RemoveCSS'
import moment from 'moment'
import PageTitle from './Common/PageTitle/PageTitle'
import statesList from '../util/statesList'

function OnboardingModalTwo(props) {
    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>
            <Modal.Body className="onboard-modal">
                <h2 className="pb-20">One last thing before you're set up!</h2>
                <div className="flex License-Onboarding-Wrap">
                    <Button className="button-green" onClick={() => props.AddAnotherLicenseOnboarding()}>
                        Add Another License
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

function AddLicense(props) {
    const [state, setState] = useState('')
    const [licenseNumber, setLicenseNumber] = useState('')
    const [expiration, setExpiration] = useState(new Date())
    const [standing, setStanding] = useState(false)
    const [addedLicense, setAddedLicense] = useState(false)

    const submitLicenseForm = () => {
        setAddedLicense(true)
        if (state !== '' && licenseNumber !== '') {
            props.processLicense(state, licenseNumber, expiration, standing)
        }
    }

    return (
        <Modal {...props} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body className="onboard-modal">
                <Form id={'licenseForm'}>
                    {(state === '' || licenseNumber === '') && addedLicense && <p className="text-red">Make sure all fields are filled out</p>}
                    <Form.Group controlId="formState">
                        <Form.Label>State</Form.Label>
                        <Form.Control required value={state} as={'select'} onChange={e => setState(e.target.value)}>
                            <option defaultValue="">Select State</option>
                            {statesList.map((item, i) => {
                                return (
                                    <option key={i} value={item.value}>
                                        {item.label}
                                    </option>
                                )
                            })}
                        </Form.Control>
                    </Form.Group>

                    <Form.Group className="mt-3" controlId="formLicenseNumber">
                        <Form.Label>License Number</Form.Label>
                        <Form.Control required value={licenseNumber} type="text" onChange={e => setLicenseNumber(e.target.value)} />
                    </Form.Group>
                    <Form.Group className="mt-3" controlId="formExpiration">
                        <Form.Label>Expiration</Form.Label>
                         <DatePicker selected={expiration} onChange={date => setExpiration(date)} />
                    </Form.Group>
                    <Form.Group className="mt-3" controlId="formStanding">
                        <Form.Check checked={standing} type="checkbox" label="In Good Standing" onChange={e => setStanding(!standing)} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <Button variant="light" onClick={() => props.onHide()}>
                        Close
                    </Button>
                    <Button variant="light" style={{ color: 'white', background: '#866BD9' }} onClick={() => submitLicenseForm()}>
                        Add License
                    </Button>
                </Row>
            </Modal.Footer>
        </Modal>
    )
}

const License = props => {
    const [retrievedLicenses, setRetrievedLicenses] = useState([])
    const [clinicianToken, setClinicianToken] = useState(null)
    const [errors, setErrors] = useState([])
    const [dataLoaded, setDataLoaded] = useState(false)

    const [modalShow, setModalShow] = useState(false)
    const [addModalShow, setAddModalShow] = useState(false)
    const [loading, setLoading] = useState(true)

    removeClass()

    const AddAnotherLicenseOnboarding = () => {
        setModalShow(false)
        setAddModalShow(true)
    }

    function renderTableData() {
        return retrievedLicenses.map(result => {
            const { pk, licenseState, licenseNumber, expirationDate, valid } = result
            const expirationDt = moment(expirationDate).format('MMM D, YYYY')
            return (
                <tr id={pk} key={pk}>
                    <td key={licenseState}>{licenseState}</td>
                    <td key={licenseNumber}>{licenseNumber}</td>
                    <td key={expirationDt}>{expirationDt}</td>
                    <td key={valid}>{valid ? 'yes' : 'no'}</td>
                </tr>
            )
        })
    }

    function renderErrors() {
        return errors.map((k, i) => {
            return (
                <li style={{ color: 'red' }} key={k}>
                    {k}
                </li>
            )
        })
    }

    function retrieveLicenseData() {
        if (clinicianToken != null && !dataLoaded) {
            async function getLicense() {
                try {
                    const getLicense = await ApiService.getLicense()
                    setErrors([])
                    setRetrievedLicenses(getLicense.data)
                    setDataLoaded(true)
                    setLoading(false)
                } catch (ex) {
                    console.error(ex)
                }
            }
            getLicense()
        }
    }

    useEffect(() => {
        Auth.currentSession()
            .then(sess => {
                setClinicianToken(sess.getIdToken().getJwtToken())
                retrieveLicenseData()
            })
            .catch(err => {
                console.error(err)
            })
    })

    const processLicense = (state, licenseNumber, expiration, standing) => {
        setLoading(true)
        async function postLicense() {
            try {
                // eslint-disable-next-line no-unused-vars
                const postLicense = await ApiService.postLicense({ state: state, licenseNumber: licenseNumber, expirationDate: expiration, isInGoodStanding: standing })
                setErrors([])
                setDataLoaded(false)
                retrieveLicenseData()
                setAddModalShow(false)
                if (props.refresh && typeof props.refresh == 'function') {
                    props.refresh()
                }
            } catch (err) {
                console.error(err)
            }
        }
        postLicense()
    }

    return (
        <Container fluid>
            <PageTitle titleName={'Manage Licenses'} />
            <Container fluid={'lg'}>
                {loading && (
                    <Row>
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </Row>
                )}
                {!loading && (
                    <>
                        <Row>
                            <Col>{renderErrors()}</Col>
                        </Row>
                        <Card body className="CardFullBody">
                            <Card.Title className="licenceHeader">
                                <Col>
                                    <Button id="msg_reply" onClick={() => setAddModalShow(true)}>
                                        Add/Update
                                    </Button>
                                </Col>
                            </Card.Title>
                            <Table borderless>
                                <tr className="TableHeaderRow">
                                    <td>State</td>
                                    <td>License Number</td>
                                    <td>Expiration</td>
                                    <td>Is In Good Standing</td>
                                </tr>
                                {renderTableData()}
                            </Table>
                        </Card>
                    </>
                )}
                <OnboardingModalTwo show={modalShow} onHide={() => setModalShow(false)} AddAnotherLicenseOnboarding={AddAnotherLicenseOnboarding} />
                <AddLicense show={addModalShow} onHide={() => setAddModalShow(false)} processLicense={processLicense} />
            </Container>
        </Container>
    )
}

export default License
